import { render } from "./Ankenlist.vue?vue&type=template&id=48864cdf&scoped=true&ts=true"
import script from "./Ankenlist.vue?vue&type=script&lang=ts"
export * from "./Ankenlist.vue?vue&type=script&lang=ts"

import "./Ankenlist.vue?vue&type=style&index=0&id=48864cdf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48864cdf"]])

export default __exports__